define(function (require) {

    window.lpTag = window.lpTag || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WidgetsManagerViewController = require('web-agent-framework/WidgetsManagerViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var AgentSummaryWidget = require('web-agent-widgets/AgentSummaryWidget');
    var AgentSurveyWidget = require('web-agent-widgets/AgentSurveyWidget');
    var AgentActionsWidgetContainer = require('web-agent-widgets/AgentActionsWidgetContainer');
    var ChatHistoryWidget = require('web-agent-widgets/ChatHistoryWidget');
    var OperatorAlertsWidget = require('web-agent-widgets/OperatorAlertsWidget');
    var VisitInfoWidget = require('web-agent-widgets/VisitInfoWidget');
    var AIAssistWidget = require('web-agent-widgets/AIAssistWidget');
    var PageNavigationWidget = require('web-agent-widgets/PageNavigationWidget');
    var CustomWidget = require('web-agent-widgets/CustomWidget');
    var CoBrowseWidget = require('web-agent-widgets/CoBrowseWidget');
    var ConsumerInfoWidget = require('web-agent-widgets/ConsumerInfoWidget');
    var PreDefinedWidget = require('web-agent-widgets/PreDefinedWidget');
    var PCIDataWidget = require('web-agent-widgets/PCIDataWidget');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');

    var widgets,
        widgetsArr = [],
        CUSTOM_WIDGET_APP_PREFIX = "lp_cw_", // Add prefix to custom widget class name selector, so it will be unique
        CUSTOM_WIDGET_TYPE = "iFrame",
        CORE_WIDGET_TYPE = "core",
        PARTICIPANT_TYPES = {
            SIMULATED: "SIMULATED",
            LE_REAL_TIME: "LE_REAL_TIME",
            LE_ASYNC_MESSAGING: "LE_ASYNC_MESSAGING",
            LEGACY_REAL_TIME: "LEGACY_REAL_TIME",
            LEGACY_ASYNC_MESSAGING: "LEGACY_ASYNC_MESSAGING"
        },
        messagingParticipants = [PARTICIPANT_TYPES.LE_ASYNC_MESSAGING, PARTICIPANT_TYPES.LEGACY_ASYNC_MESSAGING],
        realTimeParticipants =  [PARTICIPANT_TYPES.LE_REAL_TIME, PARTICIPANT_TYPES.LEGACY_REAL_TIME],
        blendedParticipants = [PARTICIPANT_TYPES.LE_ASYNC_MESSAGING, PARTICIPANT_TYPES.LEGACY_ASYNC_MESSAGING, PARTICIPANT_TYPES.LE_REAL_TIME, PARTICIPANT_TYPES.LEGACY_REAL_TIME],
        allParticipants = [PARTICIPANT_TYPES.LE_ASYNC_MESSAGING, PARTICIPANT_TYPES.LEGACY_ASYNC_MESSAGING, PARTICIPANT_TYPES.LE_REAL_TIME, PARTICIPANT_TYPES.LEGACY_REAL_TIME, PARTICIPANT_TYPES.SIMULATED];

    var MainWidgetsManagerViewController = WidgetsManagerViewController.extend({
        ControllerName: 'MainWidgetsManagerViewController',
        hasLiveEngage2Feature: agentLEManager.hasLiveEngage2Feature(),
        applicationType: 'MainWidgetsManagerViewController',
        waitingForWidgets: [],

        initialize: function () {
            this.logger = WebAgentLogger.getLogger(this.applicationType);
            widgets = {
                PCIDataWidget: {
                    controller: PCIDataWidget,
                    onShow: _createPCIDataWidget,
                    participants: allParticipants,
                    iconType: 'right_pane_secure_form',
                    isHiddenOnStart: true
                },
                VisitInfoWidget: {
                    controller: VisitInfoWidget,
                    onShow: _createVisitInfoWidget,
                    participants: realTimeParticipants.concat([PARTICIPANT_TYPES.SIMULATED]),
                    iconType: 'right_pane_suitcase'
                },
                AIAssistWidget: {
                    controller: AIAssistWidget,
                    onShow: _createAIAssistWidget,
                    participants: allParticipants,
                    iconType: 'right_pane_button_automate_conversation'
                },
                ConsumerInfoWidget: {
                    controller: ConsumerInfoWidget,
                    onShow: _createConsumerInfoWidget,
                    participants: messagingParticipants,
                    iconType: 'right_pane_suitcase'
                },
                PreDefinedWidget: {
                    controller: PreDefinedWidget,
                    placeholderConfig: {hasRefresh: true},
                    onCreatePlaceHolder: _initPreDefineContent,
                    participants: allParticipants,
                    iconType: 'right_pane_button_files'
                },
                PageNavigationWidget: {
                    controller: PageNavigationWidget,
                    onShow: _createPageNavigationWidget,
                    participants: realTimeParticipants.concat([PARTICIPANT_TYPES.SIMULATED]),
                    iconType: 'compass_navigation'
                },
                AgentActionsWidgetContainer: {
                    controller: AgentActionsWidgetContainer,
                    onShow: _createAgentSurveyWidget,
                    participants: realTimeParticipants,
                    iconType: 'right_pane_button_pen'
                },
                AgentSummaryWidget: {
                    controller: AgentSummaryWidget,
                    onShow: _createAgentSummaryWidget,
                    participants: messagingParticipants,
                    iconType: 'right_pane_button_pen'
                },
                ChatHistoryWidget: {
                    controller: ChatHistoryWidget,
                    onShow: _createChatHistoryWidget,
                    participants: blendedParticipants,
                    iconType: 'right_pane_button_chat_history'
                },
                OperatorAlertsWidget: {
                    controller: OperatorAlertsWidget,
                    onShow: _createOperatorAlertsWidget,
                    participants: [PARTICIPANT_TYPES.LEGACY_REAL_TIME],
                    iconType: 'right_pane_button_bell'
                },
                CoBrowseWidget: {
                    controller: CoBrowseWidget,
                    participants: blendedParticipants,
                    selfInit: true,
                    isHiddenOnStart: true
                },
                iFrame: {
                    onCreatePlaceHolder: _initCustomWidget,
                    onShow: _createCustomWidgetInstance
                }
            };

            this.customWidgetPlaceHolderDictionary = {};
            this.selectedWidgetIndex = {};
            this.unloadCustomWidget4Visitor = []; // list of visitors ID that their customWidgets didn't load do to empty customWidgetArray
            this.focusedVisitorId = null;
        },
        events: function () {
            this.bindModel({modelPath: "participants.myEngagements", callback: this.handleNewEngagements});
            this.bindModel({modelPath: "participants.simulatedEngagements", callback: this.handleNewEngagements});
            this.bindModel({modelPath: "agent.widgets", callback: this.widgetArrayChange});
            if (lpTag.WebAgent.logicController.hasCoBrowseFeature()) {
                agentLEManager.onLEEvent("lpCoBrowseController:Notification", this.onCoBrowseNotification, this);
            }
        },
        render: function () {
        }
    });

    MainWidgetsManagerViewController.prototype.widgetArrayChange = function (data) {
        var i,
            widget;

        widgetsArr = lpTag.WebAgent.widgetsController.getWidgets(data.newValue, true);

        for(i = 0; i < widgetsArr.length; i++) {
            widget = widgetsArr[i].type === CORE_WIDGET_TYPE && widgets[widgetsArr[i].name] || widgets[widgetsArr[i].type] || {};
            widgetsArr[i] = _.extend(widgetsArr[i], widget);
            if(_isWidgetEnabled(widgetsArr[i])) {
                if (widgetsArr[i].controller) {
                    this.createPlaceholder(widgetsArr[i].controller.applicationType, widgetsArr[i].iconType, widgetsArr[i].placeholderConfig);
                }
                _runCallback(widgetsArr[i].onCreatePlaceHolder, this, i);
            }
        }

        // if engagement created before widgets came from AC.
        if (this.waitingForWidgets.length > 0) {
            for (i = 0; i < this.waitingForWidgets.length; i++) {
                this.handleSingleEngagement(this.waitingForWidgets[i]);
            }
            this.waitingForWidgets.length = 0;
        }
    };

    MainWidgetsManagerViewController.prototype.handleNewEngagements = function (data) {
        var visitors = Object.keys(data.newValue);
        var visitorId;
        for (var visitor in visitors) {
            visitorId = visitors[visitor];
            this.bindModel({
                modelPath: 'participants.myEngagements.' + visitorId + '.participantState.engagementState',
                trigger: false,
                callback: this.updateCustomWidgetInstances
            });
            this.handleSingleEngagement(visitorId);
        }

    };

    MainWidgetsManagerViewController.prototype.handleSingleEngagement = function (visitorId) {
        if (!this.engagementWidgets[visitorId]) {
            this.logger.debug('handling engagment for: ' + visitorId, 'handleSingleEngagement');
            if(widgetsArr) {
                _bindVisitorEvents.call(this, visitorId);
                this.engagementWidgets[visitorId] = {};
            } else  {
                this.waitingForWidgets.push(visitorId);
            }
        }
    };

    MainWidgetsManagerViewController.prototype.getEngagementConfiguration = function (visitorId) {
        var participantPath,
            agentSkills,
            skill,
            skillId = -1,
            conversationOutcomes;

        participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
        agentSkills = lpUtils.cloneObject(this.modelController.getModelParam("agent.skillsInfo.skillInfo")) || [];
        if (agentSkills) {
            agentSkills = _.isArray(agentSkills) ? agentSkills : [agentSkills];
        }
        skill = this.modelController.getModelParam(participantPath + ".participantInfo.skill");
        if (!skill) {
            skill = this.modelController.getModelParam(participantPath + ".participantInfo.skillName");
        }
        if (skill) {
            skillId = lpTag.WebAgent.logicController.getSkillId(skill);
        }
        conversationOutcomes = agentLEManager.getConversationOutcomes(agentSkills);

        return {
            participantPath: participantPath,
            agentSkills: agentSkills,
            skill: skill,
            skillId: skillId,
            conversationOutcomes: conversationOutcomes
        };
    };

    MainWidgetsManagerViewController.prototype.updateCustomWidgetInstances = function (data) {
        if (data && data.newValue === "active") {
            var visitorId = this.getVisitorIdAccordingToKey(data.key);
            for(var i = 0; i < widgetsArr.length; i++) {
                if(widgetsArr[i].type === CUSTOM_WIDGET_TYPE && _isWidgetEnabled(widgetsArr[i])) {
                    _createCustomWidgetInstance.call(this, visitorId, null, i);
                }
            }
        }
    };

    MainWidgetsManagerViewController.prototype.getVisitorIdAccordingToKey = function (key) {
        if (!key) {
            return;
        }
        var pathArr = key.split('.');
        if (pathArr.length >= 2 && pathArr[0] === 'participants' && pathArr[1] === 'myEngagements') {
            return pathArr[2];
        }
    };


    function _createCustomWidgetInstance (visitorId, engagementConfiguration, widgetIndex) {
        if (visitorId) {
            _disposeCustomWidget.call(this, visitorId, widgetIndex);
            _createCustomWidget.call(this, visitorId, widgetIndex);
        }
    }

    function _disposeCustomWidget(visitorId, widgetIndex) {
        var applicationType = widgetsArr[widgetIndex].applicationType;
        lpTag.WebAgent.iFrameManager.removeVisitor(visitorId);

        if (this.engagementWidgets && this.engagementWidgets[visitorId] && this.engagementWidgets[visitorId][applicationType]) {
            this.engagementWidgets[visitorId][applicationType].hidden = true;
            this.engagementWidgets[visitorId][applicationType].showWidget();
            this.engagementWidgets[visitorId][applicationType].dispose();
        }
    }

    function _createCustomWidget(visitorId, widgetIndex) {
        var customWidget = widgetsArr[widgetIndex],
            applicationType = CUSTOM_WIDGET_APP_PREFIX + customWidget.name.trim().replace(/\s/g, '_');

        customWidget.visitorId = visitorId;
        if (customWidget.mode !== 'test' || privilegesController.hasAgentManagerModulePrivilege()) {
            this.engagementWidgets[visitorId][applicationType] = new CustomWidget(customWidget);
            if (!this.customWidgetPlaceHolderDictionary[applicationType].widgets) {
                this.customWidgetPlaceHolderDictionary[applicationType].widgets = {};
            }

            this.customWidgetPlaceHolderDictionary[applicationType].widgets[visitorId] = this.engagementWidgets[visitorId][applicationType];
            this.showWidgetContainer(applicationType);
        }
    }

    MainWidgetsManagerViewController.prototype.createCobrowseWidget = function (option) {
        var constructrData = {
            url: option.url,
            span: option.span || 4,
            widgetsManager: this,
            modelController: this.modelController,
            visitorId: option.visitorId || this.focusedVisitorId,
            cobrowseMode: option.cobrowseMode
        };
        this.createPlaceholder(CoBrowseWidget.applicationType, "right_pane_cobrowse");
        this.engagementWidgets[constructrData.visitorId][CoBrowseWidget.applicationType] = new CoBrowseWidget(constructrData);
    };

    MainWidgetsManagerViewController.prototype.removeCobrowseWidget = function (visitorId) {
        if (this.engagementWidgets[visitorId][CoBrowseWidget.applicationType]) {
            this.engagementWidgets[visitorId][CoBrowseWidget.applicationType].hidden = true;
            this.engagementWidgets[visitorId][CoBrowseWidget.applicationType].showWidget();
            this.engagementWidgets[visitorId][CoBrowseWidget.applicationType].dispose();
            this.engagementWidgets[visitorId][CoBrowseWidget.applicationType] = null;
            delete this.engagementWidgets[visitorId][CoBrowseWidget.applicationType];
        }
    };

    MainWidgetsManagerViewController.prototype.visitorFocused = function (data) {
        if (data.newValue) {
            var visitorId = data.newValue.appName;
            this.logger.debug('visitor focused, id: ' + visitorId, 'visitorFocused');
            if (_.isEmpty(this.engagementWidgets[visitorId])) {
                var isPermitted,
                    engagementConfiguration = this.getEngagementConfiguration(visitorId),
                    participantType = getParticipantType.call(this, visitorId);

                for (var i = 0; i < widgetsArr.length; i++) {
                    isPermitted = typeof widgetsArr[i].isPermitted === "function" ? widgetsArr[i].isPermitted.call(this, participantType) : true;
                    if (_isWidgetEnabled(widgetsArr[i], participantType) && !widgetsArr[i].selfInit && isPermitted) {
                        if (widgetsArr[i].controller && !widgetsArr[i].isHiddenOnStart) {
                                this.showWidgetContainer(widgetsArr[i].controller.applicationType);
                            }
                        _runCallback(widgetsArr[i].onShow, this, visitorId, engagementConfiguration, i);
                    } else if (widgetsArr[i].type === CORE_WIDGET_TYPE) {
                        this.hideWidgetContainer(widgetsArr[i].controller.applicationType);
                    }
                }
            }
            applyFocusedWidgetManagement.call(this, visitorId);
        }

        function applyFocusedWidgetManagement(visitorId) {
            if (typeof this.selectedWidgetIndex[visitorId] === "undefined") {
                this.selectedWidgetIndex[visitorId] = 0; // set a new visitor's selected as the first to the left
            }
            if (this.focusedVisitorId !== visitorId) {
                if (this.focusedVisitorId) {
                    this.selectedWidgetIndex[this.focusedVisitorId] = this.startWidget;
                }
                this.focusedVisitorId = visitorId;
                this.startWidget = this.selectedWidgetIndex[this.focusedVisitorId];
                this.delayedLayoutWidgets(true);
            }
        }
    };

    MainWidgetsManagerViewController.prototype.visitorDisposed = function (data) {
        if (data.newValue) {
            var visitorId = data.newValue.eventData.visitorId;
            var widgets = this.engagementWidgets[visitorId];
            lpTag.WebAgent.iFrameManager.removeVisitor(visitorId);
            for (var prop in widgets) {
                if (widgets.hasOwnProperty(prop)) {
                    widgets[prop].dispose();
                    if (this.customWidgetPlaceHolderDictionary[prop] && this.customWidgetPlaceHolderDictionary[prop].widgets && this.customWidgetPlaceHolderDictionary[prop].widgets[visitorId]) {
                        delete this.customWidgetPlaceHolderDictionary[prop].widgets[visitorId];
                    }
                }
            }
            this.engagementWidgets[visitorId] = null;
            delete this.engagementWidgets[visitorId];

            if (this.selectedWidgetIndex.hasOwnProperty(visitorId)) {
                delete this.selectedWidgetIndex[visitorId];
                if (visitorId === this.focusedVisitorId) {
                    this.focusedVisitorId = null;
                }
            }
            _unbindVisitorEvents.call(this, visitorId);
            this.unbindModel({
                modelPath: 'participants.myEngagements.' + visitorId + '.participantState.engagementState',
                callback: this.updateCustomWidgetInstances
            });

            for (var i = 0; i < this.unloadCustomWidget4Visitor.length; i++) {
                if (this.unloadCustomWidget4Visitor[i] === visitorId) {
                    this.unloadCustomWidget4Visitor.splice(i, 1);
                }
            }
        }
    };

    function _initCustomWidget(widgetIndex) {
        var customWidget = widgetsArr[widgetIndex],
            applicationType = CUSTOM_WIDGET_APP_PREFIX + customWidget.name.trim().replace(/\s/g, '_');

        widgetsArr[widgetIndex].widgetsManager = this;
        widgetsArr[widgetIndex].modelController = this.modelController;
        widgetsArr[widgetIndex].applicationType = applicationType;
        widgetsArr[widgetIndex].displayName = customWidget.name;
        widgetsArr[widgetIndex].isCustomWidget = true;
        widgetsArr[widgetIndex].hidden = true;
        widgetsArr[widgetIndex].hasRefresh = true;
        widgetsArr[widgetIndex].refreshTooltip = 'custom_widget_refresh_button';

        // If the widget is the last in the list there is no need to create it now.
        if (customWidget.mode !== 'test' || privilegesController.hasAgentManagerModulePrivilege()) {
            this.customWidgetPlaceHolderDictionary[applicationType] = this.createPlaceholder(applicationType, "custom_widget_icon", customWidget);
        }
    }

    MainWidgetsManagerViewController.prototype.CoBrowseAccept = function (msg) {
        var coBrowseChannel = lpTag.WebAgent.logicController.getEngagementChannel(msg.data.visitorId, lpTag.WebAgent.logicController.ENGAGEMENT_CHANNELS.COBROWSE);
        var dataToFunc = {
            url: coBrowseChannel.url,
            visitorId: msg.data.visitorId,
            cobrowseMode: msg.data.mode
        };
        var visitorId = msg.data.visitorId;

        if (!this.engagementWidgets[visitorId][CoBrowseWidget.applicationType]) {
            this.createCobrowseWidget(dataToFunc);

            // set's the co-browse widget to the selected widget
            var engagementWidgetCount = (Object.keys(this.engagementWidgets[visitorId]).length);
            this.selectedWidgetIndex[visitorId] = engagementWidgetCount;
            if (this.focusedVisitorId == visitorId) {
                this.startWidget = this.endWidget = engagementWidgetCount;
            }

            // re-layout the widgets
            this.delayedLayoutWidgets(true);
        } else {
            this.CoBrowseUpdateWidgetUrl(msg);
        }
    };

    MainWidgetsManagerViewController.prototype.CoBrowseUpdateWidgetUrl = function (msg) {
        var visitorId = msg.data.visitorId;

        if (this.engagementWidgets[visitorId][CoBrowseWidget.applicationType]) {
            this.engagementWidgets[visitorId][CoBrowseWidget.applicationType].updateUrl(msg.data.url);
        }
    };

    MainWidgetsManagerViewController.prototype.CoBrowseCloseWidget = function (msg) {
        if (msg.data.visitorId) {
            this.removeCobrowseWidget(msg.data.visitorId);
        }
    };

    MainWidgetsManagerViewController.prototype.onCoBrowseNotification = function (message) {
        if (message && message.data) {
            switch (message.data.type) {
                case 'event':
                    switch (message.data.name) {
                        case 'visitorAccept':
                        case 'openWidget':
                            this.CoBrowseAccept(message);
                            break;
                        case 'sessionEnded':
                        case 'invitationCanceled':
                        case 'visitorDecline':
                        case 'error':
                            this.CoBrowseCloseWidget(message);
                            break;
                    }
            }
        }
    };

    /******************************* private functions *************************************/

    function getParticipantType(visitorId) {
        if (visitorId === lpTag.WebAgent.engagementSimulator.SIMULATED_PARTICIPANT_ID) {
            return PARTICIPANT_TYPES.SIMULATED;
        } else {
            if (this.hasLiveEngage2Feature) {
                if (lpTag.WebAgent.logicController.isVisitorAsyncMessaging(visitorId)) {
                    return PARTICIPANT_TYPES.LE_ASYNC_MESSAGING;
                } else {
                    return PARTICIPANT_TYPES.LE_REAL_TIME;
                }
            } else {
                if (lpTag.WebAgent.logicController.isVisitorAsyncMessaging(visitorId)) {
                    return PARTICIPANT_TYPES.LEGACY_ASYNC_MESSAGING;
                } else {
                    return PARTICIPANT_TYPES.LEGACY_REAL_TIME;
                }
            }
        }
    }

    function _createVisitInfoWidget(visitorId) {
        this.engagementWidgets[visitorId][VisitInfoWidget.applicationType] = new VisitInfoWidget({
            widgetsManager: this,
            modelController: this.modelController,
            visitorId: visitorId,
            hidden: true
        });
    }

    function _createAIAssistWidget(visitorId) {
        this.engagementWidgets[visitorId][AIAssistWidget.applicationType] = new AIAssistWidget({
            widgetsManager: this,
            modelController: this.modelController,
            templateFile: "LP_ai_assist_widget.html",
            visitorId: visitorId,
            hidden: true
        });
    }

    function _createPageNavigationWidget(visitorId, configuration) {
        this.engagementWidgets[visitorId][PageNavigationWidget.applicationType] = new PageNavigationWidget({
            widgetsManager: this,
            visitorId: visitorId,
            modelController: this.modelController,
            templateFile: "LP_page_navigation.html",
            hidden: true
        });
    }

    function _createAgentSummaryWidget(visitorId, configuration) {
        this.engagementWidgets[visitorId][AgentSummaryWidget.applicationType] = new AgentSummaryWidget({
            widgetsManager: this,
            visitorId: visitorId,
            modelController: this.modelController,
            templateFile: "LP_agent_summary_widget.html",
            hidden: true
        });
    }

    function _createAgentSurveyWidget(visitorId, configuration) {
        if (configuration.conversationOutcomes) {
            this.engagementWidgets[visitorId][AgentActionsWidgetContainer.applicationType] = new AgentActionsWidgetContainer({
                widgetsManager: this,
                visitorId: visitorId,
                modelController: this.modelController,
                conversationOutComes: configuration.conversationOutcomes,
                templateFile: "LP_agent_actions_widget_container.html",
                myChatsOnly: true,
                hidden: true
            });
        } else {
            this.engagementWidgets[visitorId][AgentSurveyWidget.applicationType] = new AgentSurveyWidget({
                widgetsManager: this,
                lazyLoaderAppName: AgentSurveyWidget.applicationType,
                visitorId: visitorId,
                myChatsOnly: true,
                modelController: this.modelController,
                hidden: true
            });
        }
    }

    function _createChatHistoryWidget(visitorId, configuration) {
        var chatHistoryDataPath, chatHistoryStatePath;
        if (this.hasLiveEngage2Feature) {
            chatHistoryDataPath = 'engagementsHistoryByVisitor.' + visitorId + '.array';
            chatHistoryStatePath = 'engagementsHistoryByVisitor.' + visitorId + '.state';
        } else {
            chatHistoryDataPath = configuration.participantPath + '.participantInfo.chatHistory.chatHistoryRecord';
            chatHistoryStatePath = configuration.participantPath + '.participantInfo.chatHistory';
        }
        // only for now!!!! remove after chatHistory is working with messaging mode
        this.engagementWidgets[visitorId][ChatHistoryWidget.applicationType] = new ChatHistoryWidget({
            templateFile: "LP_history_widget.html",
            widgetsManager: this,
            visitorId: visitorId,
            modelController: this.modelController,
            dataPath: chatHistoryDataPath,
            statePath: chatHistoryStatePath,
            hidden: true
        });
    }

    function _createConsumerInfoWidget(visitorId) {
        this.engagementWidgets[visitorId][ConsumerInfoWidget.applicationType] = new ConsumerInfoWidget({
            widgetsManager: this,
            visitorId: visitorId,
            modelController: this.modelController,
            hidden: true
        });
    }

    function _createOperatorAlertsWidget(visitorId) {
        this.engagementWidgets[visitorId][OperatorAlertsWidget.applicationType] = new OperatorAlertsWidget({
            widgetsManager: this,
            visitorId: visitorId,
            modelController: this.modelController,
            hidden: true
        });
    }

    function _createPCIDataWidget(visitorId) {
        this.engagementWidgets[visitorId][PCIDataWidget.applicationType] = new PCIDataWidget({
            widgetsManager: this,
            visitorId: visitorId,
            modelController: this.modelController,
            hidden: true
        });
    }
    function _initPreDefineContent() {
        new PreDefinedWidget({
            widgetsManager: this,
            modelController: lpTag.WebAgent.agentController
        });
    }

    function _bindVisitorEvents(visitorId) {
        this.viewEventsHandler.bindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_FOCUSED,
            callback: this.visitorFocused
        });
        this.viewEventsHandler.bindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_DISPOSED,
            callback: this.visitorDisposed
        });
    }

    function _unbindVisitorEvents(visitorId) {
        this.viewEventsHandler.unbindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_FOCUSED,
            callback: this.visitorFocused
        });
        this.viewEventsHandler.unbindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_DISPOSED,
            callback: this.visitorDisposed
        });
    }

    function _isWidgetEnabled(widget, participantType) {
        var supportParticipantType = participantType && widget.participants ? widget.participants.indexOf(participantType) >= 0 : true;
        return supportParticipantType && widget.enabled !== false && (widget.isSupported || widget.type === CUSTOM_WIDGET_TYPE);
    }

    /**
     * Runs a callback function with a provided context,
     * returns the same value as this callback function returns
     * @param callback
     * @param context
     * @returns {*}
     */
    function _runCallback(callback, context) {
        context = context || window;
        if (typeof callback === "function") {
            var args = Array.prototype.slice.call(arguments, 2);
            try {
                return callback.apply(context, args);
            } catch (exc) {
                lpTag.log("Failed to execute callback exc= " + exc.message, 'ERROR', name);
            }
        }
    }

    window.MainWidgetsManagerViewController = MainWidgetsManagerViewController;
    return MainWidgetsManagerViewController;
});
